import React, { useEffect, useState } from "react";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  GET_ALL_AGGREGATOR,
  GET_ALL_PRIVILAGES_BY_ID,
} from "../../utils/constant";
import { Row, Offcanvas } from "react-bootstrap";
import useApiServices from "../../utils/useApiServices";

const offcanvasStyle = {
  width: "90vw",
};

const ViewSingleSubmittedAggregator = ({ id, show, onHide, refresh }) => {
  const [aggregatorData, setAggregatorData] = useState({});
  const [HeadPrivilages, setHeadPrivilages] = useState([]);

  const [formDataInputs, setFormDataInputs] = useState({
    AggregatorName: "",
    masterMerchantName: "",
    password: "",
    MobileNumber: "",
    Prifix: "",
    emailId: "",
  });
  const { apiCallFnforGet } = useApiServices();

  // const AggregatorId = id;

  useEffect(() => {
    setFormDataInputs({
      AggregatorName: aggregatorData.name,
      masterMerchantName: aggregatorData.masterMerchantId,
      password: aggregatorData.password,
      MobileNumber: aggregatorData.mobile,
      Prifix: aggregatorData.midprifix,
      emailId: aggregatorData.email,
    });
  }, [aggregatorData, id]);

  const getAggregatorData = async () => {
    try {
      const response = await apiCallFnforGet(`${GET_ALL_AGGREGATOR}/${id}`);
      if (response.statusCode === 200) {
        setAggregatorData(response?.data[0]);
      } else {
        setAggregatorData([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAllPrivilagesbyID = async () => {
    try {
      const response = await apiCallFnforGet(
        `${GET_ALL_PRIVILAGES_BY_ID}/${id}`
      );
      if (response.statusCode === 200) {
        setHeadPrivilages(response?.data || []);
      } else {
        setHeadPrivilages([]);
      }
    } catch (err) {
      console.log(err);
      setHeadPrivilages([]);
    }
  };

  const groupPrivileges = (list) => {
    const map = {};

    list.forEach((item) => {
      const headId = item.adminPrivilegeId + "";

      if (!map[headId]) {
        map[headId] = {
          adminPrivilegeId: headId,
          privilegeName: item.adminPrivilegeName,
          subTypes: [],
        };
      }

      map[headId].subTypes.push({
        adminPrivilegeSubTypeId: item.adminPrivilegeSubTypeId + "",
        subTypePrivilegeName: item.privilegeSubTypeName,
      });
    });

    return Object.values(map);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id) {
          await getAggregatorData();
        }
        await getAllPrivilagesbyID();
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [id, refresh]);

  const groupedData = groupPrivileges(HeadPrivilages);

  return (
    <>
      {/* New */}

      <Offcanvas
        show={show}
        onHide={onHide}
        placement="end"
        style={offcanvasStyle}
      >
        <div
          className="d-flex justify-content-start align-items-center mt-3"
          style={{ marginLeft: "28px" }}
        >
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <h5
            class="offcanvas-title fs-2 text-dark fw-bold"
            id="offcanvasLabel"
          >
            View Master Merchant
          </h5>
        </div>

        <Offcanvas.Body>
          <div className="card-body py-4">
            <div id="" className="form-wizard order-create">
              <div id="" className="tab-pane" role="tabpanel">
                <div className="row">
                  <div className="table-responsive">
                    <div className="table table-bordered">
                      <div className="row">
                        {[
                          {
                            label: "Master Merchant Name",
                            value: formDataInputs.AggregatorName,
                          },
                          {
                            label: "E-mail",
                            value: formDataInputs.emailId,
                          },
                          {
                            label: "Master Mobile Number",
                            value: formDataInputs.MobileNumber,
                          },
                          {
                            label: "Prifix",
                            value: formDataInputs.Prifix,
                          },
                          {
                            label: "Password",
                            value: formDataInputs.password,
                          },
                        ].map((item, index) => (
                          <div
                            key={index}
                            className="col-6 border-bottom border-dark "
                          >
                            <div className="d-flex justify-content-between align-items-center table table-bordered">
                              <tr className="fw-bold mt-2 w-100 d-flex justify-content-between align-items-center">
                                {item.label} <RemoveIcon />
                              </tr>{" "}
                              <tr className="mt-2 w-100 text-end">
                                {item.value}
                              </tr>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="pt-4">
                    <h4 className="fs-2">Privilages</h4>
                  </div>
                  <Row className="mt-3">
                    <div className="d-flex flex-column gap-4">
                      {groupedData &&
                        groupedData?.map((itemMain, i) => (
                          <div key={i} className="d-flex flex-column">
                            <div className="d-flex justify-content-start align-items-center gap-2">
                              <div class="checkbox-wrapper-31">
                                <input
                                  type="checkbox"
                                  readOnly
                                  checked={true}
                                />{" "}
                                {/* always checked */}
                                <svg viewBox="0 0 35.6 35.6">
                                  <circle
                                    class="background"
                                    cx="17.8"
                                    cy="17.8"
                                    r="17.8"
                                  ></circle>
                                  <circle
                                    class="stroke"
                                    cx="17.8"
                                    cy="17.8"
                                    r="14.37"
                                  ></circle>
                                  <polyline
                                    class="check"
                                    points="11.78 18.12 15.55 22.23 25.17 12.87"
                                  ></polyline>
                                </svg>
                              </div>

                              <h1 className="pt-2">
                                {itemMain?.privilegeName}
                              </h1>
                            </div>

                            <div className="row fs-4 mt-2 text-dark">
                              {console.log(
                                itemMain?.subTypes,
                                "itemMain?.subTypes",
                                itemMain?.privilegeName
                              )}
                              {itemMain?.subTypes?.map((subItem, idx) => (
                                <div
                                  key={idx}
                                  class="checkbox-wrapper-27 col-lg-4 col-md-6 col-sm-12 d-flex"
                                >
                                  <label class="checkbox">
                                    <input
                                      type="checkbox"
                                      readOnly
                                      checked={true}
                                    />
                                    <span class="checkbox__icon"></span>
                                    {subItem?.subTypePrivilegeName}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};
export default ViewSingleSubmittedAggregator;
